/* eslint-disable */
import xhr from '~/xhr';

export default async function({
  isServer,
  req,
  redirect,
  route,
  app: { getRouteBaseName },
  env: { baseUrl }
}) {
  if (!process.server) return;
  let isMobile = (ua = '') => {
    // return true;
    return !!ua.match(/.*Mobile.*/);
  };
  let userAgent = req ? req.headers['user-agent'] : navigator.userAgent;

  const routeName = getRouteBaseName();
  // 只有下面的官网路径需要跳ssrmobile
  const needGoSsrmobile = [
    'ssrmobile',
    'ssrmobile-room-show',
    'ssrmobile-room-game',
    'index',
    'games',
    'games-id',
    'sid',
    'show',
    'all',
    'classify',
    'bigoid',
    'userCenter-id',
    'userCenter-edit',
    'userCenter-setting'
  ].includes(routeName);
  // 如果是未定义的路由，比如 /show/in，routeName = null,这个时候也进中间件判断
  if (routeName && !needGoSsrmobile) return;

  if (route) {
    if (isMobile(userAgent)) {
      if (route.name) {
        // PC端路由跳移动端
        if (routeName === 'sid') {
          // 从分享链接跳进来
          try {
            if (!route.path.match(/.*sid\/(.*)/)[1]) {
              return redirect('/ssrmobile');
            }
            const res = await xhr.get(
              `${baseUrl}/OUserCenter/getUserInfoStudio`,
              {
                params: {
                  sid: route.path.match(/.*sid\/(.*)/)[1]
                }
              }
            );
            if (res && res.data && res.data.bigoId) {
              const query = route.query || {};
              return redirect(
                `/ssrmobile/room/${
                  res.data.videoType === 1 ? 'show' : 'game'
                }?room=${res.data.bigoId}&c=${query.c}&p=${query.p}&t=${
                  query.t
                }&b=${query.b}&sid=${route.path.match(/.*sid\/(.*)/)[1]}`
              );
            }

            return redirect('/ssrmobile');
          } catch (err) {
            // 接口报错了也放行。避免因为接口挂了真实用户无法访问页面
            console.log(err);
            return redirect('/ssrmobile');
          }
        }
        if (route.name.startsWith('games-id___') || route.name === 'games-id') {
          // 从运营分享出去的链接进来 https://www.bigo.tv/games/PUBG-Mobile
          try {
            const gameName = route.params.id;

            if (!gameName) {
              return redirect('/ssrmobile');
            }
            let gameID = '';
            const res = await xhr.get(`${baseUrl}/OInterface/getGameCategory`);

            res.data &&
              res.data.forEach((g) => {
                if (
                  g.title.replace(/\s/g, '-').replace(/\'/g, '_') === gameName
                ) {
                  gameID = g.tabId;
                }
              });

            if (!gameID) {
              return redirect('/ssrmobile');
            }

            return redirect(
              `/ssrmobile?page=game&isRoom=true&gameName=${gameName}&gameID=${gameID}`
            );
          } catch (err) {
            console.log(err);
            return redirect('/ssrmobile');
          }
        }
        if (route.name.startsWith('bigoid___') || route.name === 'bigoid') {
          // 兼容旧官网，通过bigoid定位
          try {
            if (!route.params.bigoid) {
              return redirect('/ssrmobile');
            }
            if (route.params.bigoid === 'all') {
              return redirect('/ssrmobile?page=show');
            }

            const res = await xhr.get(
              `${baseUrl}/OUserCenter/getUserInfoStudio`,
              {
                params: {
                  bigoId: route.params.bigoid
                }
              }
            );

            if (!res || !res.data) {
              return redirect('/ssrmobile');
            }
            return redirect(
              `/ssrmobile/room/${
                res.data.videoType === 1 ? 'show' : 'game'
              }?room=${route.params.bigoid}`
            );
          } catch (err) {
            // 接口报错了也放行。避免因为接口挂了真实用户无法访问页面
            console.log(err);
            return redirect('/ssrmobile');
          }
        }
        if (route.name.startsWith('show') || route.name === 'show') {
          // https://www.bigo.tv/show
          return redirect('/ssrmobile?page=show');
        }
        if (route.name.startsWith('games') || route.name === 'games') {
          // https://www.bigo.tv/games
          return redirect('/ssrmobile?page=game');
        }
        if (routeName === 'all') {
          return redirect('/ssrmobile?page=show');
        }
        // 如果没有 ssrmobile 字样，则重定向到 ssrmobile
        // 如果有 ssrmobile 字样，不处理
        if (!route.name.includes('ssrmobile')) {
          return redirect('/ssrmobile');
        }
      } else if (
        route.path &&
        route.path.match(/.*show\/(.*)/) &&
        route.path.match(/.*show\/(.*)/).length > 1
      ) {
        // 从运营分享出去的链接进来 https://www.bigo.tv/show/in
        try {
          const gameID = route.path.match(/.*show\/(.*)/)[1].toUpperCase();
          if (!gameID) {
            return redirect('/ssrmobile');
          }
          const res = await xhr.get(`${baseUrl}/OInterfaceWeb/vedioList/5`, {
            params: {
              tabType: gameID,
              fetchNum: 1
            }
          });
          if (!res) {
            return redirect('/ssrmobile');
          }
          const data = res?.data?.data || [];
          const country_name = data && data[0] && data[0].country_name;

          return redirect(
            `/ssrmobile?page=show&isRoom=true&gameName=${country_name ||
              gameID}&gameID=${gameID}`
          );
        } catch (err) {
          console.log(err);
          return redirect('/ssrmobile');
        }
      } else {
        return redirect('/ssrmobile');
      }
    } else {
      // pc端
      if (route.name) {
        if (
          route.name.startsWith('ssrmobile-room') &&
          !route.query.room.includes('.') // 拥有小数点的话，会跳转到对应域名，所以不大对
        ) {
          return redirect(`/${route.query.room}`);
        }
        if (route.name.startsWith('ssrmobile')) {
          return redirect('/'); // 跳转PC端
        }
      }
    }
  }
}
